module.exports = __webpack_public_path__ + "img/banner1.ae6d5c37.jpg";